
import { Post as PostComponent } from "@/components/Post";
import { Post } from "@/lib/types";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PostsListProps {
  posts: Post[] | undefined;
  isLoading: boolean;
  onCategoryChange?: (category: string) => void;
  selectedCategory?: string;
}

export const PostsList = ({ 
  posts, 
  isLoading,
  onCategoryChange,
  selectedCategory 
}: PostsListProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-pink-500" />
      </div>
    );
  }

  if (!posts?.length) {
    return (
      <div className="text-center py-12 bg-gradient-to-br from-pink-100 to-purple-100 dark:from-pink-900/30 dark:to-purple-900/30 p-8 rounded-3xl shadow-md">
        <p className="text-gray-600 dark:text-gray-300 text-lg mb-4">No posts found in this category.</p>
        {onCategoryChange && (
          <Button 
            className="bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white rounded-full shadow-md" 
            onClick={() => onCategoryChange("all")}
          >
            View all posts
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {posts.map((post) => (
        <PostComponent
          key={post.id}
          id={post.id || ''} 
          username={post.is_anonymous ? "Anonymous" : post.profiles?.username || "Unknown"}
          userId={post.user_id}
          content={post.content}
          imageUrl={post.image_url}
          videoUrl={post.video_url}
          likes={post.likes_count}
          comments={post.comments?.map(comment => ({
            id: comment.id || '',
            username: comment.profiles?.username || "Unknown",
            userId: comment.user_id,
            content: comment.content,
            createdAt: comment.created_at
          })) || []}
          category={post.category}
          isAnonymous={post.is_anonymous}
          createdAt={post.created_at}
        />
      ))}
    </div>
  );
};
